import "./assets/css/plugins/bootstrap.min.css";
import "./assets/scss/style.scss";
import { Toaster } from 'react-hot-toast';
import Routers from "./Router/routes";

function App() {
  return (
    <>
     <Toaster />
    <div className="App overflow-hidden">
      <Routers />
    </div>
    </>
  );
}

export default App;
